import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplicationEventNotificationComponent } from './application-event-notification.component';
import { EdAssistUIButtonLinkModule } from '@edassist-ui/button-link';
import { EdAssistUISectionModule } from '@edassist-ui/section';
import { EdAssistUIHeadingModule } from '@edassist-ui/heading';
import { EdAssistUIAnchorModule } from '@edassist-ui/anchor';
import { EmailModule } from '../email/email.module';

@NgModule({
	declarations: [ApplicationEventNotificationComponent],
	imports: [
		CommonModule,
		EdAssistUIButtonLinkModule,
		EdAssistUISectionModule,
		EdAssistUIHeadingModule,
		EdAssistUIAnchorModule,
		EmailModule
	],
	exports: [ApplicationEventNotificationComponent]
})
export class ApplicationEventNotificationModule {}
